import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FeatureHighlights = () => {
  const features = [
  {
    icon: 'Layout',
    title: 'Visual Builder',
    description: 'Drag-and-drop interface to create stunning applications',
    image: "https://images.unsplash.com/photo-1710787554730-1b416f226a21",
    imageAlt: 'Modern workspace with laptop displaying colorful web design interface with multiple windows and design tools visible on screen'
  },
  {
    icon: 'Layers',
    title: 'Template Library',
    description: 'Start with professional templates for any industry',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11a0236bb-1764651527759.png",
    imageAlt: 'Collection of website template mockups displayed on multiple devices including desktop monitor, tablet, and smartphone showing responsive design layouts'
  },
  {
    icon: 'Zap',
    title: 'Instant Deploy',
    description: 'Publish your application with a single click',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18cef8320-1766557541190.png",
    imageAlt: 'Computer screen showing deployment dashboard with green success indicators, progress bars, and analytics graphs in modern dark interface'
  }];


  return (
    <div className="space-y-6 md:space-y-8">
      <div className="text-center space-y-2">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground">
          Everything You Need to Build
        </h2>
        <p className="text-sm md:text-base text-muted-foreground">
          Powerful tools designed for creators of all skill levels
        </p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:gap-6">
        {features?.map((feature, index) =>
        <div
          key={index}
          className="group relative overflow-hidden rounded-xl bg-card border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-lg">

            <div className="flex flex-col sm:flex-row gap-4 p-4 md:p-6">
              <div className="flex-shrink-0 w-full sm:w-32 md:w-40 h-32 md:h-40 rounded-lg overflow-hidden bg-muted">
                <Image
                src={feature?.image}
                alt={feature?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />

              </div>
              
              <div className="flex-1 space-y-2 md:space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={feature?.icon} size={20} className="text-primary" />
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
                    {feature?.title}
                  </h3>
                </div>
                <p className="text-sm md:text-base text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default FeatureHighlights;